import { connect } from 'react-redux';
import Support from '../../components/Support/Support';
import SupportAction from '../actions/SupportAction';
import { supportSelector } from '../reducers/SupportReducer';

const mapStateToProps = state => ({
  categories: supportSelector.getCategories(state),
  categoriesPending: supportSelector.getCategoriesPending(state)
});

const mapDispatchToPropsFactory = (dispatch) => {
  const fetchCategories = () => {
    dispatch(SupportAction.fetchCategories());
  };

  return { fetchCategories };
};

export default connect(mapStateToProps, mapDispatchToPropsFactory)(Support);



/** WEBPACK FOOTER **
 ** ./src/redux/containers/SupportContainer.js
 **/